import { Container, Row, Col } from "react-bootstrap";
import './inspection.scss'
import { Button, Checkbox, Loader } from 'sfy-react'
import { useEffect, useRef, useState } from "react";
import constants from './constants'
import { postRequestAsync } from "./genericApi";
import ButtonContainer from "./buttonContainer";
import ErrorModal from "./Modal/errorModal";
import { getAmpleStoreDetails } from './apiInstance';
import pushToAnalytics, { getTimeDiff } from "./Analytics";

function InspectionScreen(props) {
 const { changeScreen, currentIndex } = props;
 let ampleStoreDetails = getAmpleStoreDetails();
 const PSLId = ampleStoreDetails["pslid"];
 const PSCId = constants.PSCId;
 const brandId = localStorage.getItem('ampleBrand');
 const [disableBtn, setDisableBtn] = useState(true);
 const [functional_list, setFunctionalList] = useState([]);
 const [checkedState, setCheckedState] = useState([]);
 const [CheckboxAns, setCheckboxAns] = useState({});
 const [selectedAns, setSelectedAns] = useState({});
 const [showLoader, setShowLoader] = useState(false);
 const [apiError, setError] = useState("");
 const [showModal, setShowModal] = useState(false);
 const [enterTime, setEnterTime] = useState(new Date())
 const divRef = useRef(null);
 useEffect(() => {
  if (apiError) setShowModal(true);
 }, [apiError])
 useEffect(() => {
  if (functional_list && functional_list.length) setCheckedState(new Array(functional_list.length).fill(false));
 }, [])
 useEffect(() => {
  const currentTime = new Date();
  console.log("currentTime", currentTime)
  setEnterTime(currentTime);
 }, [])
 useEffect(() => {
  (async () => {
   try {
    setShowLoader(true);
    const functional_ques = await postRequestAsync('/api/v2/TradeIn/getInspectionList', {
     "ProductSubCategoryID": PSCId,
     "BrandID": brandId,
     "PartnerServiceLocationID": PSLId,
     "Flow": "TRADE_IN"
    })
    if (functional_ques.success) {
     let data = functional_ques.data;
     setFunctionalList(data);
     if (data && data.length) {
      data.map((e, index) => {
       if (e.AnswerType == "MULTI") {
        setCheckedState(new Array(e.inspectionAnswers && e.inspectionAnswers.length).fill(false));
       }
      })
     }
     setShowLoader(false)
    } else {
     setShowLoader(false)
    }
   } catch (e) {
    setShowLoader(false)
   }
  })()
 }, []);
 const closeModal = () => {
  setShowModal(false);
  setError("");
 }
 const get_exclusive_answer_code = () => {
  if (functional_list && functional_list.length) {
   let multiQues = functional_list.filter((e, index) => (e.AnswerType == "MULTI"));
   let insData = multiQues[0].inspectionAnswers;
   let ind = multiQues && multiQues[0].inspectionAnswers && multiQues[0].inspectionAnswers.findIndex((el) => el.IsExclusiveAnswer);
   let quesCode = multiQues[0].inspectionAnswers[ind].IQACode;
   return { ind: ind, quesCode: quesCode }
  }

 }
 const handleOnClick = (id, e, ans, index) => {
  let sa = selectedAns;
  let ca = CheckboxAns;
  if (e.AnswerType == 'SINGLE') {
   sa[e.QuestionCode] = {
    Answer: ans.Answer,
    Question: e.Question,
    IQACode: ans.IQACode
   };
   setSelectedAns(sa);
   e && e.inspectionAnswers && e.inspectionAnswers.forEach((p) => {
    var element = document.getElementById(`inspection-div ${p.IQACode}`);
    if (element) element.classList.remove("selected_product");
   });

   var el = document.getElementById(id);
   if (el) el.classList.add("selected_product");
   let len = Object.keys(sa) && Object.keys(sa).length || 0;
   let len2 = Object.keys(CheckboxAns) && Object.keys(CheckboxAns).length || 0;
   if (len2 && len == functional_list.length - 1) {
    setDisableBtn(false);
   } else {
    setDisableBtn(true);
   }
  } else {
   let code = get_exclusive_answer_code(ans);
   let updatedCheckedState = checkedState.map((item, position) => {
    return (index === position ? !item : (ans.IsExclusiveAnswer ? false : item))
   });
   setCheckedState(updatedCheckedState);
   if (!updatedCheckedState[index]) {
    console.error("please deselect");
    if (ca && Object.keys(ca).length && Object.keys(ca[ans.IQACode]).length > 0) {
     console.error("item found");
     delete ca[ans.IQACode];
    }
   }

   if (ans.IsExclusiveAnswer) {
    ca = {};
   }
   else {
    if (code && code.ind) updatedCheckedState[code.ind] = false;
    const saArray = Object.entries(ca);
    const filteredSaArray = saArray.filter(([key]) => key !== code.quesCode);
    const filteredSa = Object.fromEntries(filteredSaArray);
    ca = filteredSa;
   }
   if (updatedCheckedState[index]) {
    ca[ans.IQACode] = {
     Answer: ans.Answer,
     Question: e.Question,
     IQACode: ans.IQACode
    };
   }
   e && e.inspectionAnswers && e.inspectionAnswers.forEach((p, index) => {
    var element = document.getElementById(`inspection-div ${p.IQACode}`);
    if (element && updatedCheckedState[index]) {
     element.classList.add("selected_product");
    }
    else if (element && !updatedCheckedState[index]) {
     element.classList.remove("selected_product");
    }
   });
   console.log("final ca ", ca);
   setCheckboxAns(ca);
   let len = Object.keys(selectedAns) && Object.keys(selectedAns).length || 0;
   let exists = updatedCheckedState.some((x) => x);
   if (exists && (len == functional_list.length - 1)) {
    setDisableBtn(false);
   } else {
    setDisableBtn(true);
   }
  }


 }
 const on_continue_btn_click = () => {
  let singleAns = selectedAns && Object.keys(selectedAns).map((p, index) => {
   return selectedAns[p].IQACode;
  });
  let multiAns = CheckboxAns && Object.keys(CheckboxAns);
  let insAns = singleAns.concat(multiAns);
  let ansCodes = JSON.stringify(insAns)
  localStorage.setItem('ampleInspectionAns', ansCodes);
  pushToAnalytics(
   'Device Condition - Confirm',
   {
    Unique_Key:localStorage.getItem('ampleUniquekey'),
    Time_Spent_On_Device_Condition_Screen: getTimeDiff(new Date(), enterTime),
    Answer_Codes: ansCodes
   }
  );
  changeScreen('finalScreen');
  currentIndex(3);
 }
 const on_back_btn_click = () => {
  pushToAnalytics(
   'Device Condition - Back',
   {
    Unique_Key:localStorage.getItem('ampleUniquekey'),
    Time_Spent_On_Device_Condition_Screen: getTimeDiff(new Date(), enterTime)
   }
  );
  changeScreen('deviceDetails');
  currentIndex(2);
 }
 return (
  <Container fluid className="p-0 m-0 g-0 container-bgClr" style={{ height: "100%" }}>
   {
    showLoader ?
     <Loader />
     :
     ''
   }
   {apiError && <ErrorModal error={apiError} showModal={showModal} closeModal={closeModal} onClick={closeModal} /> || ""}

   <div className="p-20">
    <div className="ins-screen-header">
     Device Condition
    </div>
    <div className="ins-screen-subheader">Please provide information about the condition of your old device so we can calculate its exchange value</div>

    <div ref={divRef} className='inspection-div-parent'>
     {
      functional_list && functional_list.map((e, index) => {
       return <div key={index}  > < Row key={index} style={{ marginTop: '30px' }}>
        <Col xs={12}>
         <div className='tr-rd-header'>
          {e.AnswerType == "SINGLE" ? e.Question : `${e.Question} (select one or more options)`
          }
         </div>
        </Col>
        <Col xs={12}>
         <div className="ins-sub-desc">
          {
           e.inspectionAnswers && e.inspectionAnswers.map((ans, index) => {
            return <Button id={`inspection-div ${ans.IQACode}`} key={index} type='button' text={ans.Answer} classes='ins_small_ghost_btn'
             handleOnClick={() => {
              handleOnClick(`inspection-div ${ans.IQACode}`, e, ans, index)
             }} >
            </Button>
           })
          }
         </div>
        </Col>
       </Row>

       </div>
      })
     }

    </div>
   </div>
   <div style={{ paddingBottom: '10px' }}>
    <ButtonContainer
     isDisabled={disableBtn}
     BtnOneText={'Confirm'}
     BtnTwoText={'Back'}
     onBtnOneClick={on_continue_btn_click}
     onBtnTwoClick={on_back_btn_click}
     BtnOneClass={'pwa-continue-btn'}
     BtnTwoClass={'pwa-secondary-continue-btn'} />
   </div>
  </Container >
 );
}
export default InspectionScreen;